<template>
    <div id="Brand">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title">
                <span style="font-size: 16px; font-weight: 600;">{{langText.BrandManufacturing}}</span>
            </div>
        </nav-bar>
        <div style="margin-top: 46px"></div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    :finished-text="commonText.noMore"
                    @load="onLoad">
              <brand :brand="brandList"/>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    import { Icon, PullRefresh, List, Toast, Image, Divider } from "vant"
    import NavBar from "../../components/common/navbar/NavBar";
    import brand from "../../components/content/brand/brand";
    import {getBrandList} from "../../network/index";
    import { langPackage } from "@/config/lang/brand";
    import { selectLang } from "@/config/setLanguage"

    export default {
        name: "Brand",
        components: {
            NavBar: NavBar,
            [ Icon.name ]: Icon,
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
            [Toast.name]: Toast,
            [Image.name]: Image,
            [Divider.name]: Divider,
            brand:brand,
        },
        data(){
            return{
                loading: false,
                finished: false,
                refreshing: false,
                brandList: [],
                pageNum: 0,
                pageSize: 10,
                langText:"",
                commonText:"",
            }
        },
        methods: {
            goBack() {
                this.$router.back(-1);
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;
                // 重新加载数据
                this.pageNum = 0;
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.onLoad();
            },
            onLoad() {
                // 加载list
                getBrandList({pageNum: this.pageNum, pageSize: this.pageSize}).then(res => {
                    if(this.refreshing){
                        this.refreshing = false;
                        this.brandList = res.data;
                        this.loading = false;
                    }else {
                        this.brandList= this.brandList.concat(res.data);
                        this.loading = false;
                    }
                    if(res.data < this.pageSize){
                        this.finished = true
                    }
                    this.pageNum++;
                })
            },
            toBrandList(id) {
                this.$router.push({path: '/goods/GoodsList', query: {'brandId': id}})
            }
        },
        created() {
            selectLang(langPackage).then(langtxt =>{
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;
            });
            this.onRefresh();
        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";

    #Brand{
        background: #f8f6f7;
        /*background: #1b1f23;*/
        width: 100%;
        /*height: 800px;*/
    }

    .van-nav-bar {
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, .5);
        background-color: #ffffff;
    }



</style>
